import { AxiosResponse } from 'axios'

const isResponse = (
  response: Response | AxiosResponse<unknown>,
): response is Response => {
  return response['ok'] !== undefined
}

/**
 * @throws {Error}
 */
const checkValidImageResponse = (
  response: Response | AxiosResponse<unknown>,
): void => {
  const contentType = isResponse(response)
    ? response.headers.get('content-type')
    : response.headers['content-type']

  if (!contentType) {
    throw new Error('Response does not have a content-type header')
  }

  if (!contentType.startsWith('image/')) {
    throw new Error('Response is not an image')
  }
}

export default checkValidImageResponse
